
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
class AlertBox extends Vue {
  @Prop({ default: null }) readonly slug!: string;
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default: null }) readonly heading!: string;
  @Prop({ default: null }) readonly message!: string;
  @Prop({ default: false }) readonly bothButtons!: boolean;

  cancel(): void {
    this.$bvModal.hide("team-modal-alert-edit");
  }

  ok(): void {
    this.$emit("alertOk");
    this.$bvModal.hide("team-modal-alert-edit");
  }
}

export default AlertBox;
